import { signInWithEmailAndPassword, signOut } from "firebase/auth";

import { auth, AuthAPI } from "../../auth";
import { PortalAPI } from "../infrastructure/portalApi";

/** The patient's own name and profile, as the portal shows it. */
export async function getPortalMe() {
  const { data } = await PortalAPI.getMe();
  return data;
}

export async function signInPatient(email: string, password: string) {
  await signInWithEmailAndPassword(auth, email, password);
}

export async function signOutPatient() {
  await signOut(auth);
}

export async function sendPatientPasswordReset(email: string, language: string) {
  await AuthAPI.sendPasswordResetEmail(email, language);
}

/** The patient ending their own portal account. Not an erasure: the clinical
 *  records stay with each treating therapist. */
export async function deletePortalAccount() {
  await PortalAPI.deleteAccount();
}

/** Everything the portal holds about the patient, as the raw export body. */
export async function downloadPortalExport() {
  const { data } = await PortalAPI.downloadExport();
  return data;
}
